import { OneSchemaTemplateColumn, OneSchemaTemplateColumnToAdd } from '@oneschema/react';

/**
 * Creates a template column object.
 * @param label {String}
 * @param key {String}
 * @param isRequired {Boolean}
 * @param mustExist {Boolean}
 * @param dataType {String}
 * @param validationOptions {Object}
 * @return {OneSchemaTemplateColumnToAdd}
 */
export const createTemplateColumn = (
  label: string,
  key: string,
  isRequired: boolean,
  mustExist?: boolean,
  dataType?: OneSchemaTemplateColumn['data_type'],
  validationOptions?: {
    [key: string]: any;
  }
): OneSchemaTemplateColumnToAdd => ({
  is_required: isRequired,
  key,
  ...(dataType && { data_type: dataType as OneSchemaTemplateColumn['data_type'] }),
  label,
  must_exist: mustExist,
  ...(validationOptions && { validation_options: validationOptions })
} as OneSchemaTemplateColumnToAdd);
